// extracted by mini-css-extract-plugin
export var graphic = "fullWidthResponsiveGraphic-module--graphic--29948";
export var title = "fullWidthResponsiveGraphic-module--title--a9649";